module.exports = __webpack_public_path__ + "img/codigo api correios 4.c242ee00.png";